'use strict';

import angular from 'angular';
import {BuscarArticuloRouteComponent} from './buscar-articulo-route.component.js';
const ngRoute = require('angular-route');

/*@ngInject*/
const routeArticulos = function ($routeProvider) {
    $routeProvider
        .when('/articulo/categoria/:categoria', {
            template: '<buscar-articulo-route articulos="$resolve.articulos.data" subcategorias="$resolve.subcategorias.data"></buscar-articulo-route>',
            resolve: {
                articulos: getArticulosPorCategoria,
                subcategorias: getSubcategoriasPorCategoria
            },
            authenticate: true
        })
        .when('/articulo/categoria/:categoria/:subcategoria', {
            template: '<buscar-articulo-route articulos="$resolve.articulos.data" subcategorias="$resolve.subcategorias.data"></buscar-articulo-route>',
            resolve: {
                articulos: getArticulosPorSubcategoria,
                subcategorias: getSubcategoriasPorCategoria
            },
            authenticate: true
        })
        .when('/articulo/codigo/:codigo', {
            template: '<buscar-articulo-route articulos="$resolve.articulos.data"></buscar-articulo-route>',
            resolve: {
                articulos: getArticulosPorCodigo
            },
            authenticate: true
        })
        .when('/articulo/palabra-clave/:palabra', {
            template: '<buscar-articulo-route articulos="$resolve.articulos.data"></buscar-articulo-route>',
            resolve: {
                articulos: getArticulosPalabraClave
            },
            authenticate: true
        });

    function getArticulosPorCategoria(ArticuloService, $route) {
        return ArticuloService.getArticulosPorCategoria($route.current.params.categoria)
    }

    function getArticulosPorSubcategoria(ArticuloService, $route) {
        return ArticuloService.getArticulosPorSubcategoria($route.current.params.categoria, $route.current.params.subcategoria)
    }

    function getSubcategoriasPorCategoria(ArticuloService, $route) {
        return ArticuloService.getSubcategoriasPorCategoria($route.current.params.categoria);
    }

    function getArticulosPorCodigo(ArticuloService, $route) {
        return ArticuloService.getArticulosPorCodigo($route.current.params.codigo)
    }

    function getArticulosPalabraClave(ArticuloService, $route, $window) {

        let palabra = $route.current.params.palabra = $route.current.params.palabra.replace(/%2F/g, '/');

        return ArticuloService.getArticulosPorPalabraClave($window.encodeURIComponent(palabra));
    }
};

export default angular.module('pizzutoAutopartesApp.buscar-articulo', [ngRoute])
    .component(BuscarArticuloRouteComponent.selector, BuscarArticuloRouteComponent)
    .config(routeArticulos)
    .name;



// WEBPACK FOOTER //
// ./client/app/buscar-articulo-route/index.js